import React, { Component } from 'react';
import style from './style.css';
import CSSModules from 'react-css-modules';
import DropList from '../dropList';
import Button from '../button';
import { Radio } from 'antd';
const RadioGroup = Radio.Group;

class ApplyCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            classType:'',
            student: '',
            lesson: ''
        }

        this.radioSelect = (e) => {
            this.setState({
                classType: e.target.value
            })
        }

        this.onSelected = (e) => {
            this.onSelected = (name, value) => {
                this.setState({
                    [name]: value.value
                })
            }
        }

        this.onSubmit = (e) => {
            if(this.checkValid(this.state)) this.props.onSubmit(this.state);
        }
    }

    checkValid(state) {
        if( state.classType.length <= 0 || 
            (state.classType === 'single' ) && (state.student.length <= 0 || state.lesson.length <= 0)
        ) return false;
        else return true;
    }

    render(){

        const { studentData, dateData, className } = this.props;

        return (
            <div styleName="cardBlock" className={this.props.className}>
                <RadioGroup onChange={this.radioSelect} styleName="radioGroup">
                    <Radio value="fixed" styleName="radio">每週體驗</Radio>
                    <Radio value="single" styleName="radio">單次體驗</Radio>
                </RadioGroup>
                <div styleName="rightBlock">
                    <p>我想成為親子班的固定學生。</p>
                    <p>先報名一次，體驗課程內容後再決定是否長期上課。</p>
                    { this.state.classType === 'single' && 
                        <table styleName="single">
                            <tbody>
                                <tr>
                                    <td>學生</td>
                                    <td><DropList 
                                        listContent={studentData}
                                        onSelected={this.onSelected.bind(this, 'student')}
                                        width={130}/></td>
                                </tr>
                                <tr>
                                    <td>上課日期</td>
                                    <td><DropList 
                                        listContent={dateData}
                                        onSelected={this.onSelected.bind(this, 'lesson')}
                                        width={130}/>
                                        </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                </div>
                
                
                <Button onClick={this.onSubmit} styleName="button">報名</Button>
            </div>
        );
    }
}
export default CSSModules(ApplyCard,style,{allowMultiple:true});


/** WEBPACK FOOTER **
 ** ./src/component/classBar/applyCard.js
 **/